import { useState, useEffect } from 'react';

interface Customer {
  id?: number;
  ad_soyad: string;
  telefon: string;
  email: string;
  notlar: string;
}

interface Props {
  customer?: Customer | null;
  onSave: (data: Omit<Customer, 'id'>) => Promise<void>;
  onClose: () => void;
  saving: boolean;
}

const EMPTY: Omit<Customer, 'id'> = { ad_soyad: '', telefon: '', email: '', notlar: '' };

export default function MusteriModal({ customer, onSave, onClose, saving }: Props) {
  const [form, setForm] = useState<Omit<Customer, 'id'>>(EMPTY);

  useEffect(() => {
    if (customer) {
      const { id: _id, ...rest } = customer as Customer;
      setForm({ ...EMPTY, ...rest });
    } else {
      setForm(EMPTY);
    }
  }, [customer]);

  const set = (key: keyof typeof EMPTY, value: string) =>
    setForm(prev => ({ ...prev, [key]: value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.ad_soyad.trim()) return;
    await onSave(form);
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-vip-dark border border-vip-gold/15 rounded-xl w-full max-w-md">
        <div className="flex items-center justify-between p-5 border-b border-vip-gold/10">
          <h3 className="text-base font-semibold text-white">{customer ? 'Müşteriyi Düzenle' : 'Yeni Müşteri Ekle'}</h3>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-vip-gold/10 text-gray-400 hover:text-white transition-colors">
            <i className="ri-close-line"></i>
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div>
            <label className="block text-xs text-gray-400 mb-1.5">Ad Soyad *</label>
            <input value={form.ad_soyad} onChange={e => set('ad_soyad', e.target.value)} required
              placeholder="Ahmet Yılmaz" className="w-full bg-vip-black border border-vip-gold/15 rounded-md px-3 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-vip-gold/40" />
          </div>
          <div>
            <label className="block text-xs text-gray-400 mb-1.5">Telefon</label>
            <input value={form.telefon} onChange={e => set('telefon', e.target.value)}
              placeholder="+90 555 123 4567" className="w-full bg-vip-black border border-vip-gold/15 rounded-md px-3 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-vip-gold/40" />
          </div>
          <div>
            <label className="block text-xs text-gray-400 mb-1.5">E-posta</label>
            <input type="email" value={form.email} onChange={e => set('email', e.target.value)}
              placeholder="ahmet@email.com" className="w-full bg-vip-black border border-vip-gold/15 rounded-md px-3 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-vip-gold/40" />
          </div>
          <div>
            <label className="block text-xs text-gray-400 mb-1.5">Notlar</label>
            <textarea value={form.notlar} onChange={e => set('notlar', e.target.value)} rows={3}
              placeholder="Müşteri hakkında notlar..." maxLength={500}
              className="w-full bg-vip-black border border-vip-gold/15 rounded-md px-3 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-vip-gold/40 resize-none" />
          </div>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 py-2.5 rounded-md bg-vip-black border border-vip-gold/10 text-gray-400 text-sm hover:text-white transition-colors whitespace-nowrap">İptal</button>
            <button type="submit" disabled={saving || !form.ad_soyad.trim()}
              className="flex-1 py-2.5 rounded-md bg-vip-gold text-vip-black font-semibold text-sm hover:bg-vip-gold-light transition-colors disabled:opacity-50 whitespace-nowrap">
              {saving ? 'Kaydediliyor...' : customer ? 'Güncelle' : 'Ekle'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}